import { get } from '../../../../util/api'
import * as type from './type'


export const getScanFolderContentRequest = () => ({
    type: type.GET_SCAN_FOLDER_CONTENT_REQUEST,
})

export const getScanFolderContentSuccess = (fileList) => ({
    type: type.GET_SCAN_FOLDER_CONTENT_SUCCESS,
    payload: {
        fileList,
    },
})

export const getScanFolderContentError = (error) => ({
    type: type.GET_SCAN_FOLDER_CONTENT_ERROR,
    payload: {
        error,
    },
})

export const getScanFolderContent = (folderId) => (dispatch, getState) => {
    dispatch(getScanFolderContentRequest())

    get('/api/store/get-scan-folder-content?folderId=' + folderId)
        .then(fileList => {
            dispatch(getScanFolderContentSuccess(fileList))
        })
        .catch(error => {
            dispatch(getScanFolderContentError(error))
        })
}




// WEBPACK FOOTER //
// ./src/modules/customer/state/transfer-drive-files/action.js